import { render, staticRenderFns } from "./Caminho.vue?vue&type=template&id=ab5be8da&scoped=true&"
import script from "./Caminho.vue?vue&type=script&lang=js&"
export * from "./Caminho.vue?vue&type=script&lang=js&"
import style0 from "./Caminho.vue?vue&type=style&index=0&id=ab5be8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5be8da",
  null
  
)

export default component.exports